import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function HandoffCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const accessToken = params.get('access_token');
    const next = params.get('next') || '/admin/dashboard';
    if (!accessToken) {
      navigate('/admin/login', { replace: true });
      return;
    }
    localStorage.setItem('admin_token', accessToken);
    navigate(next, { replace: true });
  }, [navigate, params, user]);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
      Completing secure sign-in…
    </div>
  );
}
